import { useState } from 'react';

export default function CodeBlock({ code, language = 'json', label }) {
  const [copied, setCopied] = useState(false);

  if (!code) return null;

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API unavailable — fail silently.
    }
  }

  return (
    <div className="code-block">
      <div className="code-block-header">
        <span className="code-block-label">{label || language.toUpperCase()}</span>
        <button type="button" className="code-block-copy" onClick={handleCopy}>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <pre>
        <code>{code}</code>
      </pre>
    </div>
  );
}
